import { useInfiniteQuery } from 'react-query';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import {
  GetDepositTransactionResponse,
  getDepositTransactions,
} from '@app/store/transport-layer/payment/deposit/transactions';

const DEPOSIT_TRANSACTION_PAGE_LIMIT = 10;

function useDepositTransactions(depositId: string | null) {
  const workspaceId = useWorkspaceId();

  const query = useInfiniteQuery<GetDepositTransactionResponse>({
    queryKey: ['deposit-transactions', workspaceId, depositId],
    queryFn: ({ pageParam: offset = 0 }) =>
      getDepositTransactions({
        workspaceId,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        depositId: depositId!,
        offset,
        limit: DEPOSIT_TRANSACTION_PAGE_LIMIT,
      }),
    getNextPageParam: ({ count: totalCount }, allPages) => {
      const fetchCount = allPages.reduce((acc, cur) => acc + cur.transactions.length, 0);

      return fetchCount < totalCount ? fetchCount : undefined;
    },
    enabled: !!depositId,
  });

  return {
    ...query,
    data: query.data?.pages.flatMap((page) => page.transactions),
  };
}

export default useDepositTransactions;
